// Type Imports
import type { ChildrenType, Direction } from '../@core/types';

import { SettingsProvider } from '../@core/contexts/settingsContext';
// Context Imports
import { VerticalNavProvider } from '../@menu/contexts/verticalNavContext';

// Util Imports
import { getMode, getSettingsFromCookie, getSystemMode } from '../@core/utils/serverHelpers';
import ThemeProvider from './theme';

type Props = ChildrenType & {
  direction: Direction;
};

const Providers = (props: Props) => {
  // Props
  const { children, direction } = props;

  // Vars
  const mode = getMode();
  const settingsCookie = getSettingsFromCookie();
  const systemMode = getSystemMode();

  return (
    <VerticalNavProvider>
      <SettingsProvider settingsCookie={settingsCookie} mode={mode}>
        <ThemeProvider direction={direction} systemMode={systemMode}>
          {children}
        </ThemeProvider>
      </SettingsProvider>
    </VerticalNavProvider>
  );
};

export default Providers;
